/* eslint-disable no-restricted-globals */
/* eslint-disable no-undef */
import axios from 'axios';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import DOMPurify from 'dompurify';
import Swal from 'sweetalert2';
import * as XLSX from "xlsx"
import jsPDF from 'jspdf';
import * as htmlToImage from 'html-to-image';

const regex = /^\/reset\/[\dA-Za-z]*$/;

export const roles = [1, 2, 3 ];

export const customSwal = Swal.mixin({
    showClass: {
        popup: 'animate-fade-down animate-duration-300 animate-normal'
    },
    hideClass: {
        popup: 'animate-fade-up animate-duration-200 animate-alternate-reverse'
    },
    customClass: {
        title: 'leading-normal',
    }
});

export const validarEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
}

export const paginationProps = {
    rowsPerPageText: 'Filas por página',
    rangeSeparatorText: 'de',
};

/* export const validateSession = () => {
    let token = Cookies.get('Bearer');

    if (token === undefined || token === null) {
        window.location = "/Login";
        return null;
    }

    let parsedToken = (token);

    return {
        token: parsedToken,
        role: parsedToken.role,
        type: parsedToken.type,
        data: parsedToken.data,
    };
}; */

export const getSession = () => {
    if (Cookies.get(process.env.REACT_APP_USER) === undefined) {
        // Si no existe la cookie, redireccionamos al login
        // window.location = "/";
        return null;
    }
    // console.log(JSON.parse(decryptData(Cookies.get(process.env.REACT_APP_USER))));
    // Si existe la cookie, retornamos los datos del usuario
    return JSON.parse(decryptData(Cookies.get(process.env.REACT_APP_USER)));
}

export const hasNetworkConnection = () => {
    try {
        if (!navigator.onLine) {
            return false;
        }

        return true;
    } catch (error) {
        return false;
    }
};

export const hasStableNetwork = async () => {
    try {
        let testUri = process.env.REACT_APP_API_URI + "info" || 'https://ecoeficiencia.fundemas.org/api/info';
        
        let response = await axios.head(testUri, { timeout: 5000 });
        
        if (response.status >= 200 && response.status < 300) {
            return true;
        } 

        return false;
    } catch (error) {
        return false;
    }
};

export const getOrDeleteRequest = async (action, method, responseType = null, auth = true) => {
    if (!hasNetworkConnection()) {
        Swal.fire({
            title: 'Sin conexión a internet',
            text: 'No hay conexión a internet. Por favor, verifica tu conexión e inténtalo de nuevo.',
            icon: 'warning',
            confirmButtonText: 'Aceptar',
            timer: 5000
        });
        return {
            type: 'error',
            message: 'No hay conexión a internet. Por favor, verifica tu conexión e inténtalo de nuevo.',
            data: {},
        };
    }

    if (!await hasStableNetwork()) {
        Swal.fire({
            title: 'Conexión inestable',
            text: 'La conexión a internet es inestable. Por favor, verifica tu conexión e inténtalo de nuevo.',
            icon: 'warning',
            confirmButtonText: 'Aceptar',
            timer: 5000
        });

        return {
            type: 'error',
            message: 'La conexión a internet es inestable. Por favor, verifica tu conexión e inténtalo de nuevo.',
            data: {},
        };
    }

    let uri = `${process.env.REACT_APP_API_URI}${action}`;

    let config = {
        method: method,
        url: uri,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    };

    if (auth) {
        let token = decryptData(Cookies.get(process.env.REACT_APP_TOKEN));

        // console.log(token, "token");

        config.headers['Authorization'] = `Bearer ${token}`;

        config.url = uri;
    }

    if (responseType !== null) {
        config.responseType = responseType;
    }

    try {
        const response = await axios(config);

        if (Array.isArray(response.data)) {
            return response.data;
        }

        return { ...response.data, type: 'success' };
    } catch (error) {
        console.error(error);

        // Agregando tipo al objeto error
        let errorResponse = { ...error.response.data, type: 'error' };

        return errorResponse;
    }
}

export const postOrPutRequest = async (action, method, data, auth = true, onUploadProgress = null) => {
    if (!hasNetworkConnection()) {
        Swal.fire({
            title: 'Sin conexión a internet',
            text: 'No hay conexión a internet. Por favor, verifica tu conexión e inténtalo de nuevo.',
            icon: 'warning',
            confirmButtonText: 'Aceptar',
            timer: 5000
        });
        return {
            type: 'error',
            message: 'No hay conexión a internet. Por favor, verifica tu conexión e inténtalo de nuevo.',
            data: {},
        };
    }

    if (!hasStableNetwork()) {
        Swal.fire({
            title: 'Conexión inestable',
            text: 'La conexión a internet es inestable. Por favor, verifica tu conexión e inténtalo de nuevo.',
            icon: 'warning',
            confirmButtonText: 'Aceptar',
            timer: 5000
        });

        return {
            type: 'error',
            message: 'La conexión a internet es inestable. Por favor, verifica tu conexión e inténtalo de nuevo.',
            data: {},
        };
    }

    let uri = `${process.env.REACT_APP_API_URI}${action}`;

    let config = {
        headers: {
            'Content-Type': (method.toLowerCase() === 'post') ? 'multipart/form-data' : 'application/json',
            'Accept': 'application/json',
        }
    };

    if (auth && location.pathname !== "/" && !regex.test(location.pathname)) {
        let token = decryptData(Cookies.get(process.env.REACT_APP_TOKEN));

        config.headers['Authorization'] = `Bearer ${token}`;
    }

    try {
        const response = await axios({
            method: method,
            url: uri,
            data: data,
            headers: config.headers,
            onUploadProgress: onUploadProgress
        });

        return { ...response.data, type: 'success' };
    } catch (error) {
        console.error(error);

        // Agregando tipo al objeto error
        let errorResponse = { ...error.response.data, type: 'error' };

        return errorResponse;
    }
}

export const validateData = (data) => {
    let errors = [];
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    let password = '';
    data.map((item) => {
        if (item.value === '' || item.value === undefined || item.value === null || item.value === 0) {
            errors.push({
                inputName: item.name,
                message: "Campo requerido",
                status: true
            });
            return;
        }

        if (item.name === 'email') {
            if (!validarEmail(item.value)) {
                errors.push({
                    inputName: item.name,
                    message: "Correo electrónico inválido",
                    status: true
                });
            }
            return;
        }

        // Validar que password tenga al menos 8 caracteres, letras, números y caracteres especiales
        if (item.name === 'password') {
            password = item.value;
            if (item.value.length < 8) {
                errors.push({
                    inputName: item.name,
                    message: "La contraseña debe tener al menos 8 caracteres",
                    status: true
                });
            } else {
                const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}$/;
                if (!regex.test(item.value)) {
                    errors.push({
                        inputName: item.name,
                        message: "La contraseña debe tener letras mayúsculas, letras minúsculas, números y caracteres especiales como $@!%*?&",
                        status: true
                    });
                }
            }
            return;
        }

        if (item.name === 'password_confirmation') {
            if (item.value !== password) {
                errors.push({
                    inputName: item.name,
                    message: "Las contraseñas no coinciden",
                    status: true
                });
            }
            return;
        }

        // if(item.name === 'start_year' || item.name === 'end_year'){
        //     if(item.value > year ){
        //         console.log("Años validados");
        //         errors.push({
        //             inputName: item.name,
        //             message: "El año debe ser menor",
        //             status: true
        //         });
        //     }
        //     return;
        // }

        if (Array.isArray(item.value)) {
            if (item.value.length === 0) {
                errors.push({
                    inputName: item.name,
                    message: "Debe seleccionar al menos una opción",
                    status: true
                });
            }
            return;
        }

        errors.push({
            inputName: item.name,
            message: "",
            status: false
        });
        return;
    });
    return errors;
}

export const encryptData = (data) => {
    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRET_KEY), {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    });
    const encryptedPassword = iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
    return encryptedPassword;
};

export const decryptData = (encryptedData) => {
    const encryptedDataBytes = CryptoJS.enc.Base64.parse(encryptedData);
    const iv = CryptoJS.lib.WordArray.create(encryptedDataBytes.words.slice(0, 4));
    const ciphertext = CryptoJS.lib.WordArray.create(encryptedDataBytes.words.slice(4), encryptedDataBytes.sigBytes - 16);
    const decrypted = CryptoJS.AES.decrypt({ ciphertext: ciphertext }, CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRET_KEY), {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
};

export const sanitize = (obj) => {
    const sanitizedObject = {};

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const value = obj[key];

            if (Array.isArray(value)) {
                sanitizedObject[key] = value.map(item => {
                    if (typeof item === 'string') {
                        return DOMPurify.sanitize(item, { USE_PROFILES: { html: false } });
                    }
                    return item;
                });
            } else {
                sanitizedObject[key] = DOMPurify.sanitize(value, { USE_PROFILES: { html: false } });
            }
        }
    }

    return sanitizedObject;
};

/* export const logOut = async () => {
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'Authorization': `Bearer ${decryptData(Cookies.get(process.env.REACT_APP_TOKEN))}`
        }
    };

    let uri = `${process.env.REACT_APP_API_URI}auth/logout`;

    try {
        const response = await axios({
            method: "POST",
            url: uri,
            data: {},
            headers: config.headers,
        });

        return { ...response.data, type: 'success' };
    } catch (error) {
        console.error(error);

        // Agregando tipo al objeto error
        let errorResponse = { ...error.response.data, type: 'error' };

        return { ...error.response.data, type: 'error' };
    }
} */

export const LogOut = async () => {
    let response = await postOrPutRequest(
        `auth/logout`,
        'POST',
        {}
    );
    // console.log(response);
    if (response.type === 'success') {
        Cookies.remove(process.env.REACT_APP_TOKEN);
        Cookies.remove(process.env.REACT_APP_USER);
        Swal.fire({
            title: 'Sesión cerrada',
            text: response.message,
            icon: 'success',
            confirmButtonText: 'Aceptar',
            timer: 3000
        }).then(() => {
            window.location.href = '/';
        });
    } else {
        Swal.fire({
            title: 'Error!',
            text: response.message,
            icon: 'error',
            confirmButtonText: 'Aceptar',
        });
    }
};

export const getRole = () => {
    if (Cookies.get(process.env.REACT_APP_USER) === undefined) {
        // Si no existe la cookie, redireccionamos al login
        // window.location = "/";
        return null;
    }

    // Si existe la cookie, retornamos el rol
    return JSON.parse(decryptData(Cookies.get(process.env.REACT_APP_USER))).type_id;
};

export const formatDate = (data) => {
    // Date: 03/2025
    let date = data.split('/');
    let month = date[0];
    let year = date[1];
    let monthName = '';

    switch (month) {
        case '01':
            monthName = 'Ene';
            break;
        case '02':
            monthName = 'Feb';
            break;
        case '03':
            monthName = 'Mar';
            break;
        case '04':
            monthName = 'Abr';
            break;
        case '05':
            monthName = 'May';
            break;
        case '06':
            monthName = 'Jun';
            break;
        case '07':
            monthName = 'Jul';
            break;
        case '08':
            monthName = 'Ago';
            break;
        case '09':
            monthName = 'Sep';
            break;
        case '10':
            monthName = 'Oct';
            break;
        case '11':
            monthName = 'Nov';
            break;
        case '12':
            monthName = 'Dic';
            break;
        default:
            break;
    }

    return `${monthName} ${year}`;
};

//Formatear fecha 01-02-2024 a Febrero de 2024
export const formatDate2 = (date) => {
    let dateArray = date.split('-');
    let month = dateArray[1];
    let year = dateArray[2];
    let monthName = '';

    switch (month) {
        case '01':
            monthName = 'Ene';
            break;
        case '02':
            monthName = 'Feb';
            break;
        case '03':
            monthName = 'Mar';
            break;
        case '04':
            monthName = 'Abr';
            break;
        case '05':
            monthName = 'May';
            break;
        case '06':
            monthName = 'Jun';
            break;
        case '07':
            monthName = 'Jul';
            break;
        case '08':
            monthName = 'Ago';
            break;
        case '09':
            monthName = 'Sep';
            break;
        case '10':
            monthName = 'Oct';
            break;
        case '11':
            monthName = 'Nov';
            break;
        case '12':
            monthName = 'Dic';
            break;
        default:
            break;
    }

    return `${monthName} ${year}`;
};

//Formatear fecha "2024-12-01" a Diciembre 2024
export const formatDate3 = (date) => {
    let dateArray = date.split('-');
    let month = dateArray[1];
    let year = dateArray[0];
    let monthName = '';

    switch (month) {
        case '01':
            monthName = 'Ene';
            break;
        case '02':
            monthName = 'Feb';
            break;
        case '03':
            monthName = 'Mar';
            break;
        case '04':
            monthName = 'Abr';
            break;
        case '05':
            monthName = 'May';
            break;
        case '06':
            monthName = 'Jun';
            break;
        case '07':
            monthName = 'Jul';
            break;
        case '08':
            monthName = 'Ago';
            break;
        case '09':
            monthName = 'Sep';
            break;
        case '10':
            monthName = 'Oct';
            break;
        case '11':
            monthName = 'Nov';
            break;
        case '12':
            monthName = 'Dic';
            break;
        default:
            break;
    }

    return `${monthName} ${year}`;
};

export const convertNumberIntToDecimal = (number) => {
    // Comprobar si el número es un entero y si no, devolverlo tal cual con los dos decimales
    if (Number.isInteger(number)) {
        return number;
    } else {
        // return number.toFixed(2);
        return number;
    }
};

export const formatDate4 = (date) => {
    const [part1, part2, part3] = date.split('-');

    let year, month;

    // Si el primer número tiene 4 dígitos, asumimos que es el año
    if (part1.length === 4) {
        year = part1;
        month = part2;
    } else {
        year = part3;
        month = part2;
    }

    const monthNames = {
        '01': 'Ene',
        '02': 'Feb',
        '03': 'Mar',
        '04': 'Abr',
        '05': 'May',
        '06': 'Jun',
        '07': 'Jul',
        '08': 'Ago',
        '09': 'Sep',
        '10': 'Oct',
        '11': 'Nov',
        '12': 'Dic',
    };

    return `${monthNames[month]} ${year}`;
};

//Formatear fecha "14-05-2025 22:35:53" a "14 de Mayo de 2025 10:35PM"
export const formatDate5 = (date) => {
    let dateArray = date.split(' ');
    let datePart = dateArray[0].split('-');
    let timePart = dateArray[1].split(':');
    let day = datePart[0];
    let month = datePart[1];
    let year = datePart[2];
    let hour = timePart[0];
    let minute = timePart[1];
    let second = timePart[2];
    let monthName = '';

    switch (month) {
        case '01':
            monthName = 'Ene';
            break;
        case '02':
            monthName = 'Feb';
            break;
        case '03':
            monthName = 'Mar';
            break;
        case '04':
            monthName = 'Abr';
            break;
        case '05':
            monthName = 'May';
            break;
        case '06':
            monthName = 'Jun';
            break;
        case '07':
            monthName = 'Jul';
            break;
        case '08':
            monthName = 'Ago';
            break;
        case '09':
            monthName = 'Sep';
            break;
        case '10':
            monthName = 'Oct';
            break;
        case '11':
            monthName = 'Nov';
            break;
        case '12':
            monthName = 'Dic';
            break;
        default:
            break;
    }

    // Cambiar el formato de 24 horas a 12 horas
    if (hour > 12) {
        hour -= 12;
        return `${day} de ${monthName} de ${year} ${hour}:${minute}PM`;
    } else if (hour === '00') {
        return `${day} de ${monthName} de ${year} 12:${minute}AM`;
    } else {
        return `${day} de ${monthName} de ${year} ${hour}:${minute}AM`;
    }
};

// De 2025-05-15T06:12:54.000000Z a // 15 de Mayo de 2025 06:12AM

export const formatTableReports = (data) => {
    let date = new Date(data);
    let day = date.getDate();
    let month = date.getMonth() + 1; // Los meses en JavaScript son 0-indexados
    let year = date.getFullYear();
    let hour = date.getHours();
    let minute = date.getMinutes();

    // Convertir el mes a su nombre
    const monthNames = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
    let monthName = monthNames[month - 1];

    // Cambiar el formato de 24 horas a 12 horas
    let ampm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12;
    hour = hour ? hour : 12; // La hora '0' debe mostrarse como '12'

    return `${day} de ${monthName} de ${year} ${hour}:${minute < 10 ? '0' + minute : minute}${ampm}`;
}

export const serializeExportData = (data, type = null) => {
    let result = [];

    Object.entries(data).forEach(([date, company]) => {
        let fullDate = date.slice(0, 7);

        Object.entries(company).forEach(([company, results]) => {
            let companyName = company.replace(/^\d+__/, "");
            // console.log('results', results);
            let row = {
                'Fecha de reporte': fullDate,
                'Empresa': companyName,
                'Tipo de empresa': results.company_type,
            };

            Object.entries(results).forEach(([indicator, data]) => {
                if (indicator !== "company_type") {
                    let indicatorName = indicator.replace(/^\d+__/, "");
                    indicatorName = indicatorName.replace(/_/g, " ") + " (Ind)";
                    // console.log('indicatorName', indicatorName);
                    let indicatorValue = {
                        [indicatorName]: data.result ?? 0,
                    };

                    Object.entries(data).forEach(([key, value]) => {
                        // console.log(key, value);
                        if (key !== 'result' && key !== 'calculate_terms') {
                            let keyName = key.replace(/_/g, " ");
                            // Ponemos la primera letra en mayúscula
                            keyName = keyName.charAt(0).toUpperCase() + keyName.slice(1) + ` (Ter)`;

                            let termValue = {
                                [keyName]: value ?? 0,
                            }

                            // Combinar ambos objetos
                            indicatorValue = { ...indicatorValue, ...termValue };
                        }
                    });

                    // Combinar ambos objetos
                    row = { ...row, ...indicatorValue };
                }
            });

            result.push(row);
        });
    });

    // Remove number like 0: {} 
    // result = result.map(item => {
    //     let newItem = {};
    //     Object.entries(item).forEach(([key, value]) => {
    //         if (!/^\d+$/.test(key)) {
    //             newItem[key] = value;
    //         }
    //     });
    //     return newItem;
    // });

    return result;
};

export const generateExcelFile = (data, type = null) => {
    const wb = XLSX.utils.book_new();
    const wsData = XLSX.utils.json_to_sheet(data);

    // Ajustar ancho de columnas
    const colWidths = Object.keys(data[0]).map((key) => ({
    wch: Math.max(
        key.length,
        ...data.map((row) =>
        row[key] ? row[key].toString().length : 0
        )
    ) + 2,
    }));
    wsData["!cols"] = colWidths;

    XLSX.utils.book_append_sheet(wb, wsData, "Datos del Proyecto");

    // 🔹 Nombre del archivo
    const fileName = `reporte_proyecto_${new Date().toISOString().split("T")[0]}.xlsx`;

    // 🔹 Descargar archivo
    XLSX.writeFile(wb, fileName);
    
};

async function creatPdf({
    doc,
    elements,
}) {
    let top = 20;
    const padding = 10;

    for (let i = 0; i < elements.length; i++) {
        const el = elements.item(i);
        const imgData = await htmlToImage.toPng(el);

        let elHeight = el.offsetHeight;
        let elWidth = el.offsetWidth;

        const pageWidth = doc.internal.pageSize.getWidth();

        if (elWidth > pageWidth) {
            const ratio = pageWidth / elWidth;
            elHeight = elHeight * ratio - padding;
            elWidth = elWidth * ratio - padding;
        }

        const pageHeight = doc.internal.pageSize.getHeight();

        if (top + elHeight > pageHeight) {
            doc.addPage();
            top = 20;
        }

        doc.addImage(imgData, "PNG", padding, top, elWidth, elHeight, `image${i}`);
        top += elHeight;
    }
}

export async function exportMultipleChartsToPdf({fileName = 'charts.pdf'}) {
    const doc = new jsPDF("p", "px");

    const elements = document.getElementsByClassName("custom-chart-container");

    await creatPdf({ doc, elements });

    doc.save(fileName);
}